module.exports = __webpack_public_path__ + "img/40.89e81050.jpg";